var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1912 20.7804C15.1912 19.2941 13.9863 18.0892 12.5 18.0892C11.0137 18.0892 9.80884 19.2941 9.80884 20.7804C9.80884 22.2667 11.0137 23.4716 12.5 23.4716C13.9863 23.4716 15.1912 22.2667 15.1912 20.7804Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98114 14.0853C9.98114 11.3898 9.98114 8.69386 9.98114 5.99834C9.98114 4.64079 11.0918 3.53027 12.4492 3.53027C13.8067 3.53027 14.9173 4.64079 14.9173 5.99834V14.0853C14.9173 15.4426 13.8067 16.5532 12.4492 16.5532C11.0918 16.5532 9.98114 15.4426 9.98114 14.0853Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvent);
export default __webpack_public_path__ + "static/media/noEvent.0209df6c666830ff35347081da1449a6.svg";
export { ForwardRef as ReactComponent };